// lib/buildtemplate.js

export function applyTemplate(body, vars = {}, options = {}) {
  if (!body) return "";
  const { onMissing = "keep", delimiters = { open: "{", close: "}" } } = options;
  const open = escapeRegex(delimiters.open);
  const close = escapeRegex(delimiters.close);
  const re = new RegExp(`${open}([^${close}]+)${close}`, "g");

  return body.replace(re, (_, keyRaw) => {
    const key = String(keyRaw).trim();
    if (Object.prototype.hasOwnProperty.call(vars, key) && vars[key] != null) {
      return String(vars[key]);
    }
    if (typeof onMissing === "function") return onMissing(key);
    if (onMissing === "empty") return "";
    return `${delimiters.open}${key}${delimiters.close}`;
  });
}

export function extractPlaceholders(body, delimiters = { open: "{", close: "}" }) {
  if (!body) return [];
  const open = escapeRegex(delimiters.open);
  const close = escapeRegex(delimiters.close);
  const re = new RegExp(`${open}([^${close}]+)${close}`, "g");
  const out = new Set();
  let m;
  while ((m = re.exec(body))) {
    const key = String(m[1] || "").trim();
    if (key) out.add(key);
  }
  return [...out];
}

export function buildTemplateVars(serviceMeta = {}, opts = {}) {
  const {
    offsetDays = 0,
    locale = "el-GR",
    currency = "EUR",
    accountName = null,
    clientFullname = null,
  } = opts;

  const days = Number(offsetDays || 0);

  const typeName = serviceMeta?.typeName || serviceMeta?.service_type || "";
  const title = serviceMeta?.title || "";
  const service = typeName ? `${typeName}${title ? `: ${title}` : ""}` : title || "υπηρεσία";

  const startISO = serviceMeta?.start_date || null;
  const endISO = serviceMeta?.end_date || null;

  const start_date = startISO ? formatDate(startISO, locale) : "—";
  const deadline = endISO ? formatDate(endISO, locale) : "—";

  const priceNum = typeof serviceMeta?.price === "number" ? serviceMeta.price : null;
  const cost = priceNum != null ? formatCurrency(priceNum, locale, currency) : "—";

  // Υπολογισμός days_left από end_date όταν δεν υπάρχει στη DB
  const MS_PER_DAY = 86_400_000;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const endLocal = toLocalMidnight(endISO);
  const computedDaysLeft = endLocal ? Math.ceil((endLocal - today) / MS_PER_DAY) : null;
  const days_left =
    typeof serviceMeta?.days_left === "number" ? serviceMeta.days_left : computedDaysLeft;

  const client_fullname =
    clientFullname || serviceMeta?.client_fullname || serviceMeta?.clientName || "";

  return {
    days,
    service,
    deadline,
    cost,
    title,
    start_date,
    end_date: deadline,
    days_left,
    client_fullname,
    account_name: accountName || serviceMeta?.account_name || "",
    service_id: serviceMeta?.id ?? null,
  };
}

function formatDate(input, locale = "el-GR") {
  const d = new Date(input);
  if (Number.isNaN(d.getTime())) return String(input);
  return d.toLocaleDateString(locale);
}

function formatCurrency(amount, locale = "el-GR", currency = "EUR") {
  try {
    return new Intl.NumberFormat(locale, { style: "currency", currency }).format(amount);
  } catch {
    return `${amount.toFixed?.(2) ?? String(amount)}€`;
  }
}

function escapeRegex(s) {
  return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function toLocalMidnight(dateLike) {
  if (!dateLike) return null;
  if (typeof dateLike === "string" && /^\d{4}-\d{2}-\d{2}$/.test(dateLike)) {
    const [y, m, d] = dateLike.split("-").map(Number);
    return new Date(y, m - 1, d, 0, 0, 0, 0);
  }
  const dObj = new Date(dateLike);
  if (Number.isNaN(dObj.getTime())) return null;
  dObj.setHours(0, 0, 0, 0);
  return dObj;
}
